import { webappEnvSchema } from "./env-schema";

/**
 * Runtime environment, parsed once at module load. A malformed or missing
 * injection crashes the app immediately — that is a deploy/serving bug
 * (front-serve failed to replace the "juisci-env" script tag), never a state
 * to limp through.
 */
export const env = webappEnvSchema.parse(window.__JUISCI_ENV__);
